module.exports = __webpack_public_path__ + "static/media/practice_test.905838cc.webp";